import {
  esk900FnCommonNav,
  esk900MediaKeys,
  fnFRowStandard,
  sideLedMediaKeys,
  type FactoryKeyMap,
  type KeysConfig,
} from './common'

const factoryKeysWin: FactoryKeyMap = {
  ...fnFRowStandard,
  ...esk900FnCommonNav,
  Delete: 'SideLED_Color',
  '|_\\': 'SideLED',
  '?_/': 'LED_Color',
  Tab: 'SideLED_Mode',
}

export const esk90075Keys: KeysConfig = {
  factoryKeys: {
    win: factoryKeysWin,
    mac: { ...factoryKeysWin },
  },
  mediaKeys: [...esk900MediaKeys, ...sideLedMediaKeys],
}
